/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='bottomBar'>
        <Image position={[398, 1912]} name='bg' src='bottom_shadow' />
        <Image position={[398, 1878]} name='bg' src='bottom_bg_no_shadow' />
        <Sprite position={[1367, 1798]} name='winPanel'>
            <Image name='bg' src='win_bg' />
            <Text
                position={[52, 75]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 170,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={1000}
                name='fieldText'
                localeTextID=''
                text='$24000.00'
            />
            <Text
                position={[425, 267]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 40,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={254}
                name='label'
                localeTextID=''
                text='WIN'
            />
        </Sprite>
        <Sprite position={[604, 1907]} name='totalBet'>
            <Image name='bg' src='total_bet_bg' />
            <Button position={[650, 5]} hitArea={{ width: 100, x: 0, y: 0, type: 'rectangle', height: 130 }} name='plusButton'>
                <Sprite>
                    <Image src='plus_button_normal' />
                </Sprite>
                <Sprite>
                    <Image src='plus_button_focused' />
                </Sprite>
                <Sprite>
                    <Image src='plus_button_pressed' />
                </Sprite>
                <Sprite>
                    <Image src='plus_button_disabled' />
                </Sprite>
            </Button>
            <Button position={[5, 5]} hitArea={{ width: 100, x: 0, y: 0, type: 'rectangle', height: 130 }} name='minusButton'>
                <Sprite>
                    <Image src='minus_button_normal' />
                </Sprite>
                <Sprite>
                    <Image src='minus_button_focused' />
                </Sprite>
                <Sprite>
                    <Image src='minus_button_pressed' />
                </Sprite>
                <Sprite>
                    <Image src='minus_button_disabled' />
                </Sprite>
            </Button>
            <Text
                position={[79, 3]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 80,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={600}
                name='fieldText'
                localeTextID=''
                text='$0.50'
            />
            <Text
                position={[178, 87]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 40,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={400}
                name='label'
                localeTextID=''
                text='TOTAL BET'
            />
        </Sprite>
        <Button position={[432, 1907]} hitArea={{ width: 140, x: 0, y: 0, type: 'rectangle', height: 144 }} name='infoButton'>
            <Sprite>
                <Image src='info_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='info_button_focused' />
            </Sprite>
            <Sprite>
                <Image src='info_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='info_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[2481, 1907]} hitArea={{ width: 247, x: 0, y: 0, type: 'rectangle', height: 144 }} name='turboButtonOn'>
            <Sprite>
                <Image src='turbo_button_on_normal' />
                <Image src='turbo_icon_on_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='turbo_button_on_focused' />
                <Image src='turbo_icon_on_focused_en' />
            </Sprite>
            <Sprite>
                <Image src='turbo_button_on_pressed' />
                <Image src='turbo_icon_on_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='turbo_button_on_disabled' />
                <Image src='turbo_icon_on_disabled_en' />
            </Sprite>
        </Button>
        <Button position={[2481, 1907]} hitArea={{ width: 247, x: 0, y: 0, type: 'rectangle', height: 144 }} name='turboButtonOff'>
            <Sprite>
                <Image src='turbo_button_off_normal' />
                <Image src='turbo_icon_off_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='turbo_button_off_focused' />
                <Image src='turbo_icon_off_focused_en' />
            </Sprite>
            <Sprite>
                <Image src='turbo_button_off_pressed' />
                <Image src='turbo_icon_off_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='turbo_button_off_disabled' />
                <Image src='turbo_icon_off_disabled_en' />
            </Sprite>
        </Button>
        <Button position={[3025, 1759]} hitArea={{ x: 207, y: 207, type: 'circle', radius: 195 }} name='spinButton'>
            <Sprite>
                <Image src='spin_button_normal' />
                <Image src='spin_icon_normal' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_focused' />
                <Image src='spin_icon_focused' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pressed' />
                <Image src='spin_icon_pressed' />
            </Sprite>
            <Sprite>
                <Image src='spin_button_disabled' />
                <Image src='spin_icon_disabled' />
            </Sprite>
        </Button>
        <Text
            position={[2483, 2087]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 40,
                fontStyle: 'normal',
                fill: '#06BF00',
                align: 'left',
                fontWeight: 'bold'
            }}
            maxWidth={550}
            name='tickerRight'
            localeTextID=''
            text='PRESS SPIN BUTTON'
        />
        <Text
            position={[614, 2087]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 40,
                fontStyle: 'normal',
                fill: '#D1D1D1',
                align: 'left',
                fontWeight: 'bold'
            }}
            maxWidth={750}
            name='tickerLeft'
            localeTextID=''
            text='40 LINES BET MULTIPLIER'
        />
        <Sprite position={[2760, 1980]} name='spinSettingsPanel' />
        <Button position={[2760, 1907]} hitArea={{ width: 247, x: 0, y: 0, type: 'rectangle', height: 144 }} name='autoButton'>
            <Sprite>
                <Image src='auto_button_normal' />
                <Image src='auto_icon_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='auto_button_focused' />
                <Image src='auto_icon_focused_en' />
            </Sprite>
            <Sprite>
                <Image src='auto_button_pressed' />
                <Image src='auto_icon_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='auto_button_disabled' />
                <Image src='auto_icon_disabled_en' />
            </Sprite>
        </Button>
        <Sprite position={[2760, 1907]} name='autoSpinPanel'>
            <Image src='auto_screen' />
            <Text
                position={[13, 29]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 81,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={220}
                name='txt'
                localeTextID=''
                text='200'
            />
        </Sprite>
        <Sprite position={[2481, 1907]} name='fgPanel'>
            <Image name='bg' src='fg_bg' />
            <Text
                position={[87, 3]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 80,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'right',
                    fontWeight: 'bold'
                }}
                name='currentText'
                localeTextID=''
                text='100'
            />
            <Text
                position={[303, 3]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 80,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'left',
                    fontWeight: 'bold'
                }}
                name='terminalText'
                localeTextID=''
                text='200'
            />
            <Text
                position={[227, 36]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 40,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={60}
                name='ofLabel'
                localeTextID=''
                text='OF'
            />
            <Text
                position={[23, 87]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 40,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={480}
                name='freeGamesLabel'
                localeTextID=''
                text='FREE GAMES'
            />
        </Sprite>
        <Button position={[3025, 1759]} hitArea={{ x: 207, y: 207, type: 'circle', radius: 195 }} name='stopAutoplayButton'>
            <Sprite>
                <Image src='stop_button_normal' />
                <Image src='stop_autoplay_icon_normal_en' />
            </Sprite>
            <Sprite>
                <Image src='stop_button_focused' />
                <Image src='stop_autoplay_icon_focused_en' />
            </Sprite>
            <Sprite>
                <Image src='stop_button_pressed' />
                <Image src='stop_autoplay_icon_pressed_en' />
            </Sprite>
            <Sprite>
                <Image src='stop_button_disabled' />
                <Image src='stop_autoplay_icon_disabled_en' />
            </Sprite>
        </Button>
    </Sprite>
);
